import React, { useEffect, useState } from "react";
import AppShell from "../components/AppShell";
import { MessageCircle, Mail, Phone } from "lucide-react";
import { getConfig } from "../lib/api";

export default function Support() {
  const [cfg, setCfg] = useState({ whatsapp: "", phone: "", email: "" });

  useEffect(() => {
    getConfig().then(setCfg).catch(() => {});
  }, []);

  const wa = (cfg.whatsapp || "").replace(/\D/g, "");
  const waUrl = wa
    ? `https://wa.me/${wa}?text=${encodeURIComponent(
        "Hola, necesito soporte sobre mi proyecto en En Línea Madrid."
      )}`
    : "#";

  return (
    <AppShell title="Soporte">
      <div className="px-5 pb-6 stagger">
        <p className="text-sm text-slate-600 -mt-1">
          Te respondemos lo antes posible. Habla directamente por WhatsApp para
          una atención más rápida.
        </p>

        <a
          href={waUrl}
          target="_blank"
          rel="noreferrer"
          className="mt-5 flex items-center justify-between rounded-2xl bg-[#25D366] hover:brightness-95 transition px-5 py-4 text-white shadow-sm"
          data-testid="btn-whatsapp"
        >
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-xl bg-white/20 flex items-center justify-center">
              <MessageCircle className="w-5 h-5" />
            </div>
            <div>
              <div className="font-[Outfit] font-bold text-base leading-tight">
                Hablar por WhatsApp
              </div>
              <div className="text-xs text-white/85">Respuesta rápida en horario laboral</div>
            </div>
          </div>
          <span className="text-2xl leading-none">›</span>
        </a>

        <div className="mt-5 grid grid-cols-1 gap-2.5">
          {cfg.phone && (
            <a
              href={`tel:${cfg.phone.replace(/\s/g, "")}`}
              className="flex items-center gap-3 rounded-2xl border border-slate-200 px-4 py-3.5 hover:bg-slate-50 transition"
              data-testid="link-phone"
            >
              <div className="h-10 w-10 rounded-xl bg-slate-100 flex items-center justify-center">
                <Phone className="w-4 h-4 text-slate-700" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-[0.15em] text-slate-500">Teléfono</div>
                <div className="font-medium text-slate-900">{cfg.phone}</div>
              </div>
            </a>
          )}
          {cfg.email && (
            <a
              href={`mailto:${cfg.email}`}
              className="flex items-center gap-3 rounded-2xl border border-slate-200 px-4 py-3.5 hover:bg-slate-50 transition"
              data-testid="link-email"
            >
              <div className="h-10 w-10 rounded-xl bg-slate-100 flex items-center justify-center">
                <Mail className="w-4 h-4 text-slate-700" />
              </div>
              <div>
                <div className="text-xs uppercase tracking-[0.15em] text-slate-500">Email</div>
                <div className="font-medium text-slate-900">{cfg.email}</div>
              </div>
            </a>
          )}
        </div>
      </div>
    </AppShell>
  );
}
